module.exports = __webpack_public_path__ + "img/filter-bck-arr.10795106.svg";